<template>
<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" class="search" placeholder="Search" v-model="filters.search_term" @keyup.enter="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.authorized ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('authorized')"></span>
				<label>Authorized</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.not_authorized ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('not_authorized')"></span>
				<label>Not Authorized</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList()">Filter Dates</div>
		</div>

		<div v-if="showDetail" class="divider"></div>

		<button v-if="showDetail" class="button neutral" @click="backToList()">Back To List</button>

	</div>

    <loading v-if="loading"></loading>

	<div v-else-if="!showDetail" class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date / Time</th>
					<th class="list">Processor</th>
					<th class="list">Name</th>
					<th class="list">Reference</th>
					<th class="list right">Amount</th>
					<th class="list center">Auth</th>
				</tr>
			</thead>
			<tr v-for="(log, index) in list" class="clickable-list-item" @click="getDetail(log.gateway_log_id)">
				<td class="list">{{ log.log_time }}</td>
				<td class="list">{{ log.payment_processor_code }}</td>
				<td class="list">{{ log.full_name }}</td>
				<td class="list">{{ log.reference_number }}</td>
				<td class="list right">{{ log.amount }}</td>
				<td class="list center"><i v-if="log.authorized" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
		<div class="two-columns">
			<div>
				<label>Date / Time</label>
				<input type="text" v-model="detail.log_time" readonly>
				<label>Processor</label>
				<input type="text" v-model="detail.payment_processor_code" readonly>
				<label>Name</label>
				<input type="text" v-model="detail.full_name" readonly>
				<label>IP Address</label>
				<input type="text" v-model="detail.ip_address" readonly>
				<label>Reference</label>
				<input type="text" v-model="detail.reference_number" readonly>
				<label>Amount</label>
				<input type="text" v-model="detail.amount" readonly>
				<label>Source</label>
				<input type="text" v-model="detail.source" readonly>
			</div>
			<div>
				<label>Response</label>
				<textarea style="resize: none; height: 19em; margin: 0 0 1em 0;" readonly>{{ detail.gateway_response }}</textarea>
				<label v-if="detail.authorized"><i class="fas fa-check"></i> Authorized</label>
				<label v-else><i class="fas fa-times"></i> Not Authorized</label>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{233:'Credit Card Log'}" :tours="false"></help-popup>

</div>
</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'gateway-log',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			page: 1,
			showPagination: false,
			clientId: '',
			filters: {
				authorized: false,
				not_authorized: false,
				page: 1,
				search_term: '',
				start_date: '',
				end_date: ''
			},
			list: [],
			paging: {},
			showDetail: false,
			detail: {}
		}
	},
    created() {
		this.clearFilters()
    },
	methods: {
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		getList() {
			if (this.loading) { return }
            this.loading = true
			this.message = 'Loading credit card log...'
			this.messageStatus = 'waiting'
			this.showDetail = false
			this.detailChanged = false
			this.apiCall({ destination: 'get_list_gateway_log', data: this.filters }).then(obj => {
                this.loading = false
				this.messageStatus = obj.status
				this.message = ''
				this.list = obj.list
				this.paging = obj.paging
				this.clientId = obj.client_id
				this.showPagination = true
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getDetail(gatewayLogId) {
			this.loading = true
			this.apiCall({ destination: 'get_item_gateway_log', data: { gateway_log_id: gatewayLogId } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.clientId = obj.client_id
					this.showPagination = false
					this.detail = obj.detail
					this.showDetail = true
				}
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
		},
		backToList() {
			this.showDetail = false
			this.detail = {}
			this.showPagination = true
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		hasFilters() {
			for (var property in this.filters) {
				if (property != 'page' && this.filters[property] != '') {
					return true
				}
			}
			return false
		},
		clearFilters() {
			let filterType = this.$route.query.type || 'supplier'
			this.filters = {
				page: 1,
				search_term: '',
				authorized: '',
				not_authorized: '',
				start_date: '',
				end_date: ''
			}
			var oneMonthAgo = new Date()
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.filters.start_date = oneMonthAgo.toISOString().slice(0,10)
			this.filters.end_date = new Date().toISOString().slice(0,10)
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
